
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const HorariosExcluidosList = () => {
  const [horariosExcluidos, setHorariosExcluidos] = useState([]);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);
  const navigate = useNavigate();

  const fetchHorariosExcluidos = async () => {
    try {
      setCarregando(true);

      await axios.get(
        "https://acesso.cronosagenda.com.br/api/verificar-autenticacao",
        { withCredentials: true }
      );

      const response = await axios.get(
        "https://acesso.cronosagenda.com.br/api/horarios_excluidos",
        { withCredentials: true }
      );

      setHorariosExcluidos(response.data);
    } catch (err) {
      setErro("Erro ao buscar horários excluídos.");
      console.error("Erro ao buscar horários excluídos:", err);
    } finally {
      setCarregando(false);
    }
  };

  const handleRestaurarHorario = async (horarioExcluido) => {
    try {
      await axios.get(
        "https://acesso.cronosagenda.com.br/api/verificar-autenticacao",
        { withCredentials: true }
      );

      await axios.delete(
        "https://acesso.cronosagenda.com.br/api/horarios_excluidos",
        {
          withCredentials: true,
          data: {
            funcionario_id: horarioExcluido.funcionario_id,
            dia_da_semana: horarioExcluido.dia_da_semana,
            horario_inicio: horarioExcluido.horario_inicio,
            horario_fim: horarioExcluido.horario_fim,
          },
        }
      );

      setHorariosExcluidos(
        horariosExcluidos.filter(
          (horario) =>
            horario.funcionario_id !== horarioExcluido.funcionario_id ||
            horario.dia_da_semana !== horarioExcluido.dia_da_semana ||
            horario.horario_inicio !== horarioExcluido.horario_inicio ||
            horario.horario_fim !== horarioExcluido.horario_fim
        )
      );

      setErro("");
    } catch (err) {
      setErro("Erro ao restaurar horário.");
      console.error(err);
    }
  };

  useEffect(() => {
    fetchHorariosExcluidos();
  }, []);

  if (carregando) {
    return (
      <div className="horarios-excluidos">
        <div className="horarios-excluidos__loading">
          <span className="horarios-excluidos__spinner" />
          <p>Carregando horários excluídos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="horarios-excluidos">
      {erro && (
        <div className="horarios-excluidos__error" role="alert">
          {erro}
        </div>
      )}

      {horariosExcluidos.length === 0 ? (
        <div className="horarios-excluidos__empty">
          <div
            className="horarios-excluidos__empty-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24" fill="none">
              <rect
                x="3"
                y="5"
                width="18"
                height="16"
                rx="3"
                stroke="currentColor"
                strokeWidth="1.7"
              />
              <path
                d="M7 3v4M17 3v4M3 10h18"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
              />
              <path
                d="m9 14 6 4m0-4-6 4"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <h3>Nenhum horário excluído</h3>
          <p>
            Os horários excluídos aparecerão aqui e poderão ser restaurados.
          </p>
        </div>
      ) : (
        <div className="horarios-excluidos__container">
          <div className="horarios-excluidos__summary">
            <span className="horarios-excluidos__summary-label">
              Horários excluídos
            </span>

            <span className="horarios-excluidos__count">
              {horariosExcluidos.length}
            </span>
          </div>

          <div className="horarios-excluidos__scroll">
            <table className="horarios-excluidos__table">
              <thead>
                <tr>
                  <th className="horarios-excluidos__professional-column">
                    Profissional
                  </th>
                  <th className="horarios-excluidos__day-column">
                    Dia da semana
                  </th>
                  <th className="horarios-excluidos__time-column">
                    Horário
                  </th>
                  <th className="horarios-excluidos__actions-column">
                    Ações
                  </th>
                </tr>
              </thead>

              <tbody>
                {horariosExcluidos.map((horarioExcluido) => (
                  <tr
                    key={`${horarioExcluido.funcionario_id}-${horarioExcluido.dia_da_semana}-${horarioExcluido.horario_inicio}`}
                  >
                    <td>
                      <div
                        className="horarios-excluidos__professional"
                        title={horarioExcluido.funcionario_nome}
                      >
                        {horarioExcluido.funcionario_nome}
                      </div>
                    </td>

                    <td>
                      <span className="horarios-excluidos__day">
                        {horarioExcluido.dia_da_semana}
                      </span>
                    </td>

                    <td>
                      <span className="horarios-excluidos__time">
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="currentColor"
                            strokeWidth="1.8"
                          />
                          <path
                            d="M12 7v5l3 2"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        {horarioExcluido.horario_inicio} -{" "}
                        {horarioExcluido.horario_fim}
                      </span>
                    </td>

                    <td>
                      <button
                        type="button"
                        onClick={() =>
                          handleRestaurarHorario(horarioExcluido)
                        }
                        className="horarios-excluidos__restore-button"
                        title="Restaurar horário"
                      >
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <path
                            d="M3 11a9 9 0 1 1 2.6 6.4M3 4v7h7"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 7v5l3 2"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <span>Restaurar</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default HorariosExcluidosList;